import React from 'react';
const NotFound_404 = props => {
  return (
    <div>NotFound_404</div>
  )
}

export default NotFound_404